<template>
  <div class="display-flex align-center flex-column-mb align-start-mb pv2 pv0-dk">
    <span class="flex-mb justify-between-mb w100p-mb">Show data for last:</span>
    <div class="display-flex justify-between ml1 color-blue range-times w100p-mb ml0-mb mt0-5-mb overflow-x-hidden scroll-x-auto">
      <span class="pv0-5 pointer ph2"
        v-for="(value, key) in data"
        :class="key === selectedKey ? 'time-label' : ''"
        @click="emitValue({ value, key })"
        :key="value.label"
        >
        {{ value.label }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'bh-horizontal-timer',
  props: {
    selectedKey: {
      type: String,
      default: ''
    },
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  methods: {
    emitValue(event) {
      this.$emit('output', event)
    }
  }
}
</script>

<style scoped>
  .time-label {
    background-color: #5764b3;
    color: #ffffff;
  }
  .range-times {
    border: 1px solid #5764b3;
  }

</style>
